import { Box, Typography, Stack, Paper, IconButton, Collapse } from "@mui/material";
import { UpwardIcon } from "../Icon/UpwardIcon";
import { DownWardIcon } from "../Icon/DownWardIcon";
import { globalTheme } from "../../styles";

// Define the component with expanded and onToggle props
export const CardWithCollapse = ({ title, children, isExpanded, onToggle }) => {
  return (
    <Paper elevation={3} sx={{ padding: 2, borderRadius: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          variant="h6"
          sx={{
            color: globalTheme.primaryColor,
            borderRadius: 2,
          }}
        >
          {title}
        </Typography>
        <IconButton onClick={onToggle}>{isExpanded ? <UpwardIcon /> : <DownWardIcon />}</IconButton>
      </Stack>
      <Collapse in={isExpanded}>
        <Box marginTop={1}>{children}</Box>
      </Collapse>
    </Paper>
  );
};
